// Action
import ActionArm from './action/Arm';
import ActionBrake from './action/Brake';
import ActionDisarm from './action/Disarm';
import ActionElevate from './action/Elevate';
import ActionGoto from './action/Goto';
import ActionGripper from './action/Gripper';
import ActionLand from './action/Land';
import ActionQLand from './action/QLand';
import ActionReturn from './action/Return';
import ActionSetServo from './action/SetServo';
import ActionStickControl from './action/StickControl';
import ActionTakeoff from './action/Takeoff';
// Calibration
import CalibrationAccelerometer from './calibration/Accelerometer';
import CalibrationAirspeed from './calibration/Airspeed';
import CalibrationCompass from './calibration/Compass';
import CalibrationGyroscope from './calibration/Gyroscope';
import CalibrationLevelHorizon from './calibration/LevelHorizon';
// Camera
import CameraGimbal from './camera/Gimbal';
import CameraLiveView from './camera/LiveView';
import CameraSetAutoShoot from './camera/SetAutoShoot';
import CameraShoot from './camera/Shoot';
// Configuration
import ConfigurationParameters from './configuration/Parameters';
// Failsafe
import FailsafeBattery from './failsafe/Battery';
import FailsafeGCS from './failsafe/GCS';
import FailsafeRadio from './failsafe/Radio';
// Mission
import MissionClear from './mission/Clear';
import MissionLoad from './mission/Load';
import MissionResume from './mission/Resume';
import MissionStart from './mission/Start';
import MissionUpload from './mission/Upload';
// Mode
import ModeAltHold from './mode/AltHold';
import ModeAuto from './mode/Auto';
import ModeBrake from './mode/Brake';
import ModeFBWA from './mode/FBWA';
import ModeGuided from './mode/Guided';
import ModeLoiter from './mode/Loiter';
import ModePosHold from './mode/PosHold';
import ModeQRTL from './mode/QRTL';
import ModeRTL from './mode/RTL';
import ModeStabilize from './mode/Stabilize';
// Preflight
import PreflightInspection from './preflight/Inspection';

export {
  // Action
  ActionArm,
  ActionBrake,
  ActionDisarm,
  ActionElevate,
  ActionGoto,
  ActionGripper,
  ActionLand,
  ActionQLand,
  ActionReturn,
  ActionSetServo,
  ActionStickControl,
  ActionTakeoff,
  // Calibration
  CalibrationAccelerometer,
  CalibrationAirspeed,
  CalibrationCompass,
  CalibrationGyroscope,
  CalibrationLevelHorizon,
  // Camera
  CameraGimbal,
  CameraLiveView,
  CameraSetAutoShoot,
  CameraShoot,
  // Configuration
  ConfigurationParameters,
  // Failsafe
  FailsafeBattery,
  FailsafeGCS,
  FailsafeRadio,
  // Mission
  MissionClear,
  MissionLoad,
  MissionResume,
  MissionStart,
  MissionUpload,
  // Mode
  ModeAltHold,
  ModeAuto,
  ModeBrake,
  ModeFBWA,
  ModeGuided,
  ModeLoiter,
  ModePosHold,
  ModeQRTL,
  ModeRTL,
  ModeStabilize,
  // Preflight
  PreflightInspection,
};

const commands = [
  // Action
  ActionArm,
  ActionBrake,
  ActionDisarm,
  ActionElevate,
  ActionGoto,
  ActionGripper,
  ActionLand,
  ActionQLand,
  ActionReturn,
  ActionSetServo,
  ActionStickControl,
  ActionTakeoff,
  // Calibration
  CalibrationAccelerometer,
  CalibrationAirspeed,
  CalibrationCompass,
  CalibrationGyroscope,
  CalibrationLevelHorizon,
  // Camera
  CameraGimbal,
  CameraLiveView,
  CameraSetAutoShoot,
  CameraShoot,
  // Configuration
  ConfigurationParameters,
  // Failsafe
  FailsafeBattery,
  FailsafeGCS,
  FailsafeRadio,
  // Mission
  MissionClear,
  MissionLoad,
  MissionResume,
  MissionStart,
  MissionUpload,
  // Mode
  ModeAltHold,
  ModeAuto,
  ModeBrake,
  ModeFBWA,
  ModeGuided,
  ModeLoiter,
  ModePosHold,
  ModeQRTL,
  ModeRTL,
  ModeStabilize,
  // Preflight
  PreflightInspection,
];

export default commands;
